

import { TreeNode } from "../treeNode.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class TreeNodeSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new TreeNode(data.id, data.name, true, data.children);
        this._copyAttributes(gp, data);
        return gp;

    }

}
